import React, { useState } from 'react';
import { getBubbleColor } from './colorUtils';

const Bubble = ({
  x = 100,
  y = 100,
  size = 60,
  team = 'default',
  color = null,
  name,
  bubbleSize,
  velocity,
  connected = true,
  onClick,
  onDoubleClick,
  onPop
}) => {
  const [state, setState] = useState('normal');

  const getClassName = () => {
    let className = 'bubble';
    if (state !== 'normal') className += ` ${state}`;
    return className;
  };

  // Function to convert hex color to bubble style
  const hexToBubbleStyle = (hexColor) => {
    // Convert hex to RGB
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Create darker outer ring for gradient effect
    const outerR = Math.max(0, r - 40);
    const outerG = Math.max(0, g - 40);
    const outerB = Math.max(0, b - 40);

    return {
      background: `radial-gradient(circle at 30% 30%,
        rgba(255, 255, 255, 0.8),
        rgba(${r}, ${g}, ${b}, 0.6),
        rgba(${outerR}, ${outerG}, ${outerB}, 0.8))`,
      boxShadow: `0 0 20px rgba(${r}, ${g}, ${b}, 0.4),
        inset 0 0 10px rgba(255, 255, 255, 0.2)`
    };
  };

  // Use hex color if provided, otherwise use team-based color system
  const interpolatedStyle = color
    ? hexToBubbleStyle(color)
    : getBubbleColor(bubbleSize || 50, team);

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else if (state === 'normal') {
      setState('inflating');
      setTimeout(() => setState('popping'), 300);
      setTimeout(() => {
        if (onPop) onPop();
      }, 500);
    }
  };

  const handleMouseEnter = () => {
    // Bounce effect removed per user request
  };

  const title = velocity ?
    `${name}\nSize: ${bubbleSize}\nVelocity: dx=${velocity.dx.toFixed(4)}, dy=${velocity.dy.toFixed(4)}` :
    `${name}\nSize: ${bubbleSize}`;

  return (
    <div
      className={getClassName()}
      title={title}
      style={{
        left: x,
        top: y,
        width: size,
        height: size,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
        lineHeight: '1.1',
        padding: '2px',
        opacity: connected ? 1 : 0.6,
        zIndex: 10,
        ...interpolatedStyle
      }}
      onClick={handleClick}
      onDoubleClick={onDoubleClick}
      onMouseEnter={handleMouseEnter}
    >
      {name && (
        <div style={{
          fontSize: `${Math.max(12, size / 8)}px`,
          fontWeight: 'bold',
          marginBottom: '1px',
          wordBreak: 'break-word',
          maxWidth: '90%'
        }}>
          {name}
        </div>
      )}
    </div>
  );
};

export default Bubble;
